module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_03 (1).62284cdf.png";